import { FormControl, FormControlLabel, FormLabel, Grid, Radio, RadioGroup } from '@mui/material';
import React from 'react';

function ProfessionRadio(props) {
    return (
        <Grid item xs={12}>
            <FormControl error={props.error}>
                <FormLabel id='profession'>Please indicate your profession</FormLabel>
                <RadioGroup
                    onChange={props.onChange}
                    aria-labelledby='profession'
                    name='profession'
                    value={props.value}
                >
                    <FormControlLabel value='Physician' control={<Radio />} label='Physician' />
                    <FormControlLabel value='Nurse' control={<Radio />} label='Nurse' />
                    <FormControlLabel
                        value='Allied health professional'
                        control={<Radio />}
                        label='Allied health professional'
                    />
                    <FormControlLabel value='Other' control={<Radio />} label='Other' />
                </RadioGroup>
            </FormControl>
        </Grid>
    );
}

export default ProfessionRadio;
